var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.73 -10.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.23 12.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.637,19.38H11.808a1.524,1.524,0,0,0-1.468,1.573V40.315a1.966,1.966,0,0,1-1.893,2.027,1.966,1.966,0,0,1-1.893-2.027V15.805a1.966,1.966,0,0,1,1.893-2.027h9.574a.148.148,0,0,1,.1.042l2.423,2.4a1.407,1.407,0,0,0,1,.417H35.525a.149.149,0,0,1,.144.154v1.276a.664.664,0,1,0,1.324,0V16.79a1.524,1.524,0,0,0-1.468-1.573H21.538a.148.148,0,0,1-.1-.042l-2.427-2.4a1.425,1.425,0,0,0-1-.417H8.447A3.341,3.341,0,0,0,5.23,15.805v24.51A3.341,3.341,0,0,0,8.447,43.76h31a.686.686,0,0,0,.662-.709v-22.1A1.524,1.524,0,0,0,38.637,19.38Zm.144,22.962H11.045a3.593,3.593,0,0,0,.619-2.027V20.953a.149.149,0,0,1,.144-.154H38.637a.149.149,0,0,1,.144.154Z",
    transform: "translate(-5.23 -12.36)",
    fill: "#61748e",
    stroke: "#61748e",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.8e276b70014a40260eb526ad884045b9.svg";
export { ForwardRef as ReactComponent };